import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import dayjs from 'dayjs';

const initLogger = (orgTypeAbbrev) => {
  if (orgTypeAbbrev === 'SU')
    return (...args) => {
      console.info('SU Log:', ...args);
    }
  else
    return () => {};
};

async function exportToPdfImage(ids, filename, userInfo) {
  const logSU = initLogger(userInfo.orgTypeAbbrev);

  const dimensions = [215.9, 279.4];  // 8.5" x 11"

  const pdf = new jsPDF({orientation: 'portrait', unit: 'mm', format: dimensions, compress: true});
  logSU('instantiated jsPDF');

  const canvases = await Promise.all(ids.map(async id => {
    const input = document.getElementById(id);
    logSU('Got element', id);

    if (input) {
      const canvas = {alias: id, canvas: await html2canvas(input, {
        onclone: (clonedDoc) => {
          const clonedElem = clonedDoc.getElementById(id);

          if (clonedElem) {
            clonedElem.style.width = `${dimensions[0]}mm`;
            clonedElem.style.height = `${dimensions[1]}mm`;
            clonedElem.style.padding = '6.4mm'; // Recommended padding for printers
          }
        }
      })};
      logSU('generated canvas for', id);
      return canvas;
    }
    else return {};
  }))

  canvases.filter(e => e.alias !== undefined).forEach(({alias, canvas}, index) => {
    const imgData = canvas?.toDataURL('image/png');
    logSU('converted canvas to image/png for', alias);

    if (imgData) {
      const imgProperties = pdf.getImageProperties(imgData);
      logSU('got img properties for', alias);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      logSU('got pdfWidth for', alias);
      const pdfHeight =
        (imgProperties.height * pdfWidth) / imgProperties.width;
      logSU('got pdfHeight for', alias);

      // If this is not the first page, add a page
      if (index > 0) {
        pdf.addPage(dimensions, 'p');
        logSU('Added pdf page for', alias);
      }

      pdf.addImage(imgData, 0, 0, pdfWidth, pdfHeight, alias);
      logSU('Added pdf image for', alias);
    }
  }, 0);
  logSU('Done generating PDF');

  pdf.setProperties({title: filename});

  return pdf.output('bloburl').toString();
}

export {exportToPdfImage}